import {AxiosError, AxiosResponse} from "axios";

/**
 * Base class for writing REST services.
 */
abstract class BaseService {

  protected static resolveResponse(response: AxiosResponse) {
    return response.data;
  }

  protected static resolveErrorResponse(errorResponse: AxiosError) {
    return Promise.reject(BaseService.resolveErrorResponseData(errorResponse));
  }

  protected static resolveErrorResponseData(errorResponse: AxiosError) {
    return errorResponse.response ? errorResponse.response.data : errorResponse;
  }
}

export default BaseService;
